import { all } from 'redux-saga/effects';
import asyncAction from './asyncAction';

export default all([asyncAction]);
